<template>
  <el-dialog :close-on-click-modal="false" :visible.sync="visible" width="94%" append-to-body>
    <template slot="title">
      <div class="doc-dialog-header">
        <span class="doc-dialog-title">{{ dialogTitle }}</span>
        <div v-if="showViewToolbar" class="doc-dialog-actions">
          <el-button-group>
            <el-button v-if="showSubmit" type="primary" size="small" :disabled="approveDocActionLoading" @click="submitWorkflow">提交审批</el-button>
            <el-button v-if="showWfApprove" type="primary" size="small" :disabled="approveDocActionLoading" @click="wfApprove">审批通过</el-button>
            <el-button v-if="showWfReject" type="primary" size="small" :disabled="approveDocActionLoading" @click="wfReject">驳回</el-button>
            <el-button v-if="showApproveButton" type="primary" size="small" :disabled="approveDocActionLoading" @click="approveFromView">审核</el-button>
            <el-button v-if="showUnapprove" type="primary" size="small" :disabled="approveDocActionLoading" @click="unapproveFromView">弃审</el-button>
            <el-button
              v-if="isAuth('purchase:purchaseInquiry:convertPo') && dataForm.approveStatus === '2'"
              type="primary"
              size="small"
              @click="convertPoFromView"
            >转采购订单</el-button>
            <el-button v-if="showTrail" type="primary" size="small" @click="trailVisible = true">审批轨迹</el-button>
            <el-button v-if="isAuth('purchase:purchaseInquiry:update')" type="primary" size="small" :disabled="!canEditDoc || approveDocActionLoading" @click="readonly = false">修改</el-button>
            <el-button v-if="isAuth('purchase:purchaseInquiry:delete')" type="primary" size="small" :disabled="!canEditDoc || approveDocActionLoading" @click="deleteFromView">删除</el-button>
          </el-button-group>
          <div v-if="workflowActionHint" class="wf-hint">{{ workflowActionHint }}</div>
        </div>
      </div>
    </template>

    <el-form ref="dataForm" :model="dataForm" :rules="formRules" label-width="90px">
      <el-row>
        <el-col :span="6">
          <el-form-item label="询价单号" prop="inquiryCode">
            <el-input v-model="dataForm.inquiryCode" :disabled="formReadonly || codeReadonly || !!dataForm.inquiryId" :placeholder="codeReadonly && !dataForm.inquiryId ? '保存时自动生成' : ''" />
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="询价日期" prop="inquiryDate">
            <el-date-picker v-model="dataForm.inquiryDate" type="date" value-format="yyyy-MM-dd" style="width:100%" :disabled="formReadonly" />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="备注">
            <el-input v-model="dataForm.remark" :disabled="formReadonly" />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="6">
          <el-form-item label="需求日期">
            <el-date-picker
              v-model="defaultRequiredDate"
              type="date"
              value-format="yyyy-MM-dd"
              style="width:100%"
              :disabled="formReadonly"
              placeholder="批量填充明细"
              @change="onDefaultRequiredDateChange"
            />
          </el-form-item>
        </el-col>
      </el-row>

      <div v-if="!formReadonly" style="margin-bottom:10px;">
        <el-button type="primary" size="small" @click="materialSelectorVisible = true">选择物料</el-button>
      </div>

      <el-table border :data="dataForm.inquiryLines" :header-cell-style="{ background: '#f5f7fa', color: '#606266', textAlign: 'center' }">
        <el-table-column type="index" label="序号" width="60" header-align="center" align="center" />
        <el-table-column prop="materialCode" label="产品编码" min-width="120" header-align="center" align="left" />
        <el-table-column prop="materialName" label="产品名称" min-width="130" header-align="center" align="left" />
        <el-table-column prop="specs" label="规格" min-width="100" header-align="center" align="left" />
        <el-table-column prop="quantity" label="询价数量" width="170" header-align="center" align="left">
          <template slot-scope="scope">
            <el-input-number v-model="scope.row.quantity" :disabled="formReadonly" :min="0" :precision="2" style="width:100%" />
          </template>
        </el-table-column>
        <el-table-column prop="requiredDate" label="需求日期" width="150" header-align="center" align="left">
          <template slot-scope="scope">
            <el-date-picker v-model="scope.row.requiredDate" type="date" value-format="yyyy-MM-dd" style="width:100%" :disabled="formReadonly" />
          </template>
        </el-table-column>
        <el-table-column v-if="!formReadonly" label="操作" width="70" header-align="center" align="center">
          <template slot-scope="scope">
            <el-button type="text" size="small" @click="removeLine(scope.$index)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-form>

    <div v-if="dataForm.inquiryId" style="margin-top:16px;">
      <div style="margin-bottom:8px;display:flex;align-items:center;justify-content:space-between;">
        <span style="font-weight:600;">供应商报价</span>
        <div v-if="!formReadonly && !quoteReadonly">
          <el-button type="primary" size="small" @click="addQuoteRow">新增报价行</el-button>
          <el-button type="success" size="small" :disabled="quoteSubmitLoading" @click="saveQuotesHandle">保存报价</el-button>
        </div>
      </div>
      <el-table border :data="quoteRows" :header-cell-style="{ background: '#f5f7fa', color: '#606266', textAlign: 'center' }">
        <el-table-column type="index" label="序号" width="55" header-align="center" align="center" />
        <el-table-column prop="materialCode" label="产品编码" min-width="110" header-align="center" align="left" />
        <el-table-column prop="materialName" label="产品名称" min-width="120" header-align="center" align="left" />
        <el-table-column v-if="!quoteReadonly" prop="inquiryLineId" label="询价行" width="180" header-align="center" align="left">
          <template slot-scope="scope">
            <el-select v-model="scope.row.inquiryLineId" placeholder="选择明细" style="width:100%">
              <el-option
                v-for="line in dataForm.inquiryLines"
                :key="line.inquiryLineId"
                :label="line.materialCode + ' / ' + line.materialName"
                :value="line.inquiryLineId"
              />
            </el-select>
          </template>
        </el-table-column>
        <el-table-column prop="supplierName" label="供应商" min-width="140" header-align="center" align="left">
          <template slot-scope="scope">
            <span v-if="quoteReadonly">{{ scope.row.supplierName }}</span>
            <el-input v-else v-model="scope.row.supplierName" readonly placeholder="选择供应商">
              <el-button slot="append" @click="openSupplierForQuote(scope.$index)">选择</el-button>
            </el-input>
          </template>
        </el-table-column>
        <el-table-column prop="price" label="含税单价" width="170" header-align="center" align="left">
          <template slot-scope="scope">
            <el-input-number v-if="!quoteReadonly" v-model="scope.row.price" :min="0" :precision="2" style="width:100%" />
            <span v-else>{{ scope.row.price }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="tax" label="税点" width="120" header-align="center" align="left">
          <template slot-scope="scope">
            <el-select v-if="!quoteReadonly" v-model="scope.row.taxDictItemId" placeholder="税点" style="width:100%" @change="val => onQuoteTaxChange(scope.row, val)">
              <el-option v-for="item in taxList" :key="item.dictValue" :label="item.dictLabel || item.itemName" :value="item.dictValue" />
            </el-select>
            <span v-else>{{ scope.row.tax }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="isSelected" label="中标" width="80" header-align="center" align="center">
          <template slot-scope="scope">
            <el-tag v-if="scope.row.isSelected === '1'" type="success" size="mini">已选</el-tag>
            <span v-else>—</span>
          </template>
        </el-table-column>
        <el-table-column prop="converted" label="已转PO" width="80" header-align="center" align="center">
          <template slot-scope="scope">
            <el-tag v-if="scope.row.converted === '1'" type="info" size="mini">是</el-tag>
            <span v-else>否</span>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="120" header-align="center" align="center">
          <template slot-scope="scope">
            <el-button
              v-if="dataForm.approveStatus === '2' && scope.row.isSelected !== '1' && scope.row.converted !== '1' && isAuth('purchase:purchaseInquiry:approve')"
              type="text"
              size="small"
              @click="selectQuoteHandle(scope.row)"
            >选标</el-button>
            <el-button v-if="!quoteReadonly" type="text" size="small" @click="removeQuoteRow(scope.$index)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <span slot="footer" class="dialog-footer">
      <el-button @click="visible = false">取消</el-button>
      <el-button v-if="!formReadonly" type="primary" :disabled="submitLoading" @click="submitHandle">保存询价单</el-button>
    </span>

    <material-selector :visible.sync="materialSelectorVisible" @select-multiple="chooseMaterials" />
    <supplier-selector :visible.sync="supplierSelectorVisible" @select="chooseSupplierForQuote" />
    <workflow-trail-dialog :visible.sync="trailVisible" :workflow-instance="dataForm.workflowInstance" :tasks="trailTasks" />
  </el-dialog>
</template>

<script>
import MaterialSelector from '../../components/MaterialSelector.vue'
import SupplierSelector from '../../components/SupplierSelector.vue'
import WorkflowTrailDialog from '../../components/WorkflowTrailDialog.vue'
import request from '../../api/request'
import { docInfo } from '../../api/erp/doc'
import { fetchPerms } from '../../api/auth'
import { canShowDirectApproveButton, isWorkflowEditable, normalizeWorkflowDocUi, shouldShowWorkflowTrail } from '../../utils/workflow'

function today() {
  const d = new Date()
  const p = n => String(n).padStart(2, '0')
  return d.getFullYear() + '-' + p(d.getMonth() + 1) + '-' + p(d.getDate())
}
function newId() {
  return 'inq' + Date.now().toString(36) + Math.random().toString(36).slice(2, 10)
}
function blankForm(id) {
  return {
    inquiryId: id || '', inquiryCode: '', inquiryDate: today(), approveStatus: '', workflowStatus: 'draft',
    workflowInstance: null, myPendingTask: null, workflowDocUi: null, remark: '', inquiryLines: []
  }
}

export default {
  components: { MaterialSelector, SupplierSelector, WorkflowTrailDialog },
  data() {
    return {
      visible: false, readonly: false, submitLoading: false, approveDocActionLoading: false, quoteSubmitLoading: false,
      workflowDocUiReady: false, codeReadonly: false, materialSelectorVisible: false, supplierSelectorVisible: false,
      trailVisible: false, quoteSupplierRowIndex: -1, taxList: [], quoteRows: [], defaultRequiredDate: '',
      permCodes: [], dataForm: blankForm(),
      dataRule: {
        inquiryCode: [{
          validator: (rule, value, callback) => {
            if (this.codeReadonly) { callback(); return }
            if (!value || !String(value).trim()) callback(new Error('询价单号不能为空'))
            else callback()
          },
          trigger: 'blur'
        }],
        inquiryDate: [{ required: true, message: '询价日期不能为空', trigger: 'change' }]
      }
    }
  },
  computed: {
    formReadonly() { return this.readonly || this.dataForm.approveStatus === '2' || !this.canEditDoc },
    quoteReadonly() { return this.formReadonly },
    formRules() { return this.formReadonly ? {} : this.dataRule },
    dialogTitle() {
      if (this.readonly) return '查看询价单'
      return this.dataForm.inquiryId ? '修改询价单' : '新增询价单'
    },
    canEditDoc() { return isWorkflowEditable(this.dataForm.workflowStatus, this.dataForm.approveStatus) },
    workflowUi() { return normalizeWorkflowDocUi(this.dataForm.workflowDocUi) },
    showViewToolbar() { return this.readonly && !!this.dataForm.inquiryId },
    showApproveButton() {
      if (!this.showViewToolbar || !this.workflowDocUiReady || String(this.dataForm.approveStatus) === '2') return false
      if (!canShowDirectApproveButton(this.dataForm.workflowDocUi)) return false
      return this.isAuth('purchase:purchaseInquiry:approve') || this.isAuth('purchase:purchaseInquiry:save') || this.isAuth('purchase:purchaseInquiry:update')
    },
    showUnapprove() { return this.showViewToolbar && this.isAuth('purchase:purchaseInquiry:unapprove') && String(this.dataForm.approveStatus) === '2' },
    showSubmit() {
      const ui = this.workflowUi
      if (!this.showViewToolbar || !this.workflowDocUiReady || !ui || !ui.submitAllowed) return false
      const uid = (this.$store.state.user || {}).id
      if (this.dataForm.createBy && uid && String(this.dataForm.createBy) !== String(uid)) return false
      return this.isAuth('purchase:purchaseInquiry:submit') || this.isAuth('purchase:purchaseInquiry:save') || this.isAuth('purchase:purchaseInquiry:update')
    },
    showWfApprove() {
      const task = this.dataForm.myPendingTask
      return this.showViewToolbar && this.isAuth('workflow:task:approve') && task && task.taskId
    },
    showWfReject() {
      return this.showWfApprove && this.isAuth('workflow:task:reject')
    },
    showTrail() {
      return shouldShowWorkflowTrail({
        inViewMode: this.showViewToolbar, workflowInstance: this.dataForm.workflowInstance,
        workflowDocUi: this.workflowUi, workflowDocUiReady: this.workflowDocUiReady
      })
    },
    trailTasks() {
      const inst = this.dataForm.workflowInstance
      return (inst && inst.tasks) || []
    },
    workflowActionHint() {
      const ui = this.workflowUi
      if (!ui || !ui.workflowEnabled || String(this.dataForm.approveStatus) === '2') return ''
      if (ui.inApproval) {
        const uid = (this.$store.state.user || {}).id
        const inst = this.dataForm.workflowInstance
        if (!(this.dataForm.myPendingTask && this.dataForm.myPendingTask.taskId) && inst && uid && String(inst.submitBy) === String(uid)) {
          return '当前步骤需由其他审批人处理（不允许提交人自审），请等待待办人审批。'
        }
        return ''
      }
      if (!ui.definitionMatched && ui.submitAllowed) return '已启用多级审批，尚未配置审批流程。请点击「提交审批」查看配置指引。'
      return ''
    }
  },
  created() { fetchPerms().then(res => { this.permCodes = res.data || [] }).catch(() => {}) },
  watch: {
    quoteRows: {
      deep: true,
      handler(rows) {
        rows.forEach(row => {
          if (!row.inquiryLineId) return
          const line = this.dataForm.inquiryLines.find(l => l.inquiryLineId === row.inquiryLineId)
          if (line) {
            row.materialCode = line.materialCode
            row.materialName = line.materialName
          }
        })
      }
    }
  },
  methods: {
    isAuth(perm) {
      const user = this.$store.state.user || {}
      const codes = Array.isArray(user.roleCodes) ? user.roleCodes : []
      const role = String(user.roleCode || '')
      if (role === 'TENANT_ADMIN' || role === 'PLATFORM_ADMIN' || codes.indexOf('TENANT_ADMIN') >= 0 || codes.indexOf('PLATFORM_ADMIN') >= 0) return true
      return this.permCodes.indexOf(perm) >= 0
    },
    init(id, readonly) {
      this.readonly = !!readonly
      this.visible = true
      this.submitLoading = false
      this.approveDocActionLoading = false
      this.workflowDocUiReady = false
      this.codeReadonly = !!id
      this.quoteRows = []
      this.defaultRequiredDate = ''
      this.dataForm = blankForm(id)
      this.loadTaxList()
      this.$nextTick(() => {
        if (this.$refs.dataForm) this.$refs.dataForm.clearValidate()
        if (!id) this.resolveCode()
        if (id) this.loadDetail(id)
      })
    },
    resolveCode() {
      request.post('/base/docNumberRule/resolve', { docType: 'purchaseInquiry' }).then(res => {
        const data = res.data || {}
        this.codeReadonly = !!data.codeReadonly
        if (data.previewCode) this.dataForm.inquiryCode = data.previewCode
        this.$nextTick(() => {
          if (this.$refs.dataForm) this.$refs.dataForm.clearValidate('inquiryCode')
        })
      }).catch(() => {})
    },
    loadTaxList() {
      return request.get('/sys/dicts', { params: { dictType: 'TAX' } }).then(res => {
        this.taxList = (res.data || []).map(item => ({
          ...item,
          dictValue: item.dictValue != null ? String(item.dictValue) : String(item.itemCode || item.dictItemId || ''),
          dictLabel: item.dictLabel || item.itemName || item.dictValue
        }))
      }).catch(() => {})
    },
    resolveTaxRateNumber(dictValue) {
      const item = (this.taxList || []).find(t => String(t.dictValue) === String(dictValue))
      if (!item) return null
      const raw = item.dictValue != null ? String(item.dictValue) : (item.itemCode != null ? String(item.itemCode) : '')
      const num = Number(raw.replace(/[^0-9.]/g, ''))
      return Number.isNaN(num) ? null : num
    },
    resolveTaxDictItemId(tax) {
      if (tax == null || tax === '') return ''
      const taxNum = Number(tax)
      const hit = (this.taxList || []).find(item => {
        const v = Number(String(item.dictValue || '').replace(/[^0-9.]/g, ''))
        return !Number.isNaN(taxNum) && v === taxNum
      })
      return hit ? String(hit.dictValue) : ''
    },
    loadDetail(id) {
      docInfo('/purchase/purchaseInquiry', id).then(res => {
        const b = res.data || {}
        const lines = b.inquiryLines || b.lines || []
        this.dataForm = {
          ...blankForm(id), ...b,
          inquiryDate: (b.inquiryDate || '').slice(0, 10),
          inquiryLines: lines.map(line => ({
            ...line,
            quantity: Number(line.quantity),
            requiredDate: line.requiredDate ? String(line.requiredDate).slice(0, 10) : ''
          }))
        }
        this.workflowDocUiReady = !!normalizeWorkflowDocUi(this.dataForm.workflowDocUi)
        this.quoteRows = this.flattenQuotes(lines)
        this.initDefaultRequiredDateFromLines()
      }).catch(() => {})
    },
    flattenQuotes(lines) {
      const rows = []
      ;(lines || []).forEach(line => {
        ;(line.quotes || []).forEach(q => {
          const taxDictItemId = this.resolveTaxDictItemId(q.tax)
          rows.push({
            quoteId: q.quoteId,
            inquiryLineId: q.inquiryLineId,
            materialCode: line.materialCode,
            materialName: line.materialName,
            supplierId: q.supplierId,
            supplierName: q.supplierName,
            price: q.price != null ? Number(q.price) : null,
            taxDictItemId,
            tax: taxDictItemId ? this.resolveTaxRateNumber(taxDictItemId) : (q.tax != null ? Number(q.tax) : null),
            isSelected: q.isSelected || q.selected,
            converted: q.converted
          })
        })
      })
      return rows
    },
    initDefaultRequiredDateFromLines() {
      const dates = (this.dataForm.inquiryLines || []).map(l => (l.requiredDate ? String(l.requiredDate).slice(0, 10) : '')).filter(Boolean)
      const uniq = [...new Set(dates)]
      if (uniq.length === 1) this.defaultRequiredDate = uniq[0]
    },
    onDefaultRequiredDateChange(val) {
      if (!val) return
      ;(this.dataForm.inquiryLines || []).forEach(line => { line.requiredDate = val })
    },
    nextLineSort() {
      let max = 0
      ;(this.dataForm.inquiryLines || []).forEach(l => {
        const s = Number(l.lineSort) || 0
        if (s > max) max = s
      })
      return max + 1
    },
    chooseMaterials(materials) {
      if (!materials || !materials.length) return
      const existing = new Set((this.dataForm.inquiryLines || []).map(l => l.materialId))
      let lineSort = this.nextLineSort()
      materials.forEach(m => {
        if (existing.has(m.materialId)) return
        this.dataForm.inquiryLines.push({
          inquiryLineId: newId(),
          materialId: m.materialId,
          materialCode: m.materialCode,
          materialName: m.materialName,
          specs: m.specs,
          quantity: 1,
          lineSort: lineSort++,
          requiredDate: this.defaultRequiredDate || ''
        })
      })
    },
    removeLine(index) {
      const removed = this.dataForm.inquiryLines[index]
      if (removed && removed.inquiryLineId) {
        this.quoteRows = this.quoteRows.filter(q => q.inquiryLineId !== removed.inquiryLineId)
      }
      this.dataForm.inquiryLines.splice(index, 1)
    },
    addQuoteRow() {
      this.quoteRows.push({
        quoteId: newId(), inquiryLineId: '', materialCode: '', materialName: '',
        supplierId: '', supplierName: '', price: null, tax: null, taxDictItemId: ''
      })
    },
    openSupplierForQuote(index) {
      this.quoteSupplierRowIndex = index
      this.supplierSelectorVisible = true
    },
    chooseSupplierForQuote(supplier) {
      if (this.quoteSupplierRowIndex < 0) return
      const row = this.quoteRows[this.quoteSupplierRowIndex]
      row.supplierId = supplier.supplierId
      row.supplierName = supplier.supplierName
      this.quoteSupplierRowIndex = -1
    },
    onQuoteTaxChange(row, dictValue) {
      this.$set(row, 'taxDictItemId', dictValue != null ? String(dictValue) : '')
      this.$set(row, 'tax', this.resolveTaxRateNumber(row.taxDictItemId))
    },
    removeQuoteRow(index) { this.quoteRows.splice(index, 1) },
    submitHandle() {
      if (!this.dataForm.inquiryLines.length) {
        this.$message.error('请至少维护一条询价明细')
        return
      }
      this.$refs.dataForm.validate(valid => {
        if (!valid) return
        this.submitLoading = true
        const payload = {
          ...this.dataForm,
          inquiryLines: (this.dataForm.inquiryLines || []).map((line, index) => ({
            ...line,
            lineSort: index + 1,
            requiredDate: line.requiredDate ? String(line.requiredDate).slice(0, 10) : null
          })),
          lines: (this.dataForm.inquiryLines || []).map((line, index) => ({
            ...line,
            lineSort: index + 1,
            requiredDate: line.requiredDate ? String(line.requiredDate).slice(0, 10) : null
          }))
        }
        const url = '/purchase/purchaseInquiry/' + (this.dataForm.inquiryId ? 'update' : 'save')
        request.post(url, payload).then(() => {
          this.$message.success('保存成功')
          if (!this.dataForm.inquiryId) {
            this.visible = false
            this.$emit('refreshDataList')
          } else {
            this.loadDetail(this.dataForm.inquiryId)
            this.$emit('refreshDataList')
          }
        }).catch(() => {}).finally(() => { this.submitLoading = false })
      })
    },
    saveQuotesHandle() {
      if (!this.dataForm.inquiryId) { this.$message.warning('请先保存询价单'); return }
      if (!this.quoteRows.length) { this.$message.error('请至少维护一条报价'); return }
      for (const row of this.quoteRows) {
        if (!row.inquiryLineId || !row.supplierId || row.price == null || this.resolveTaxRateNumber(row.taxDictItemId) == null) {
          this.$message.error('请完善报价的询价行、供应商、单价与税点')
          return
        }
      }
      this.quoteSubmitLoading = true
      request.post('/purchase/purchaseInquiry/saveQuotes', {
        inquiryId: this.dataForm.inquiryId,
        quotes: this.quoteRows.map(r => ({
          quoteId: r.quoteId,
          inquiryLineId: r.inquiryLineId,
          supplierId: r.supplierId,
          price: r.price,
          tax: this.resolveTaxRateNumber(r.taxDictItemId)
        }))
      }).then(() => {
        this.$message.success('报价保存成功')
        this.loadDetail(this.dataForm.inquiryId)
      }).catch(() => {}).finally(() => { this.quoteSubmitLoading = false })
    },
    selectQuoteHandle(row) {
      this.$confirm('确定将该报价选为中标?', '提示', { type: 'warning' }).then(() => {
        request.post('/purchase/purchaseInquiry/selectQuote', { quoteId: row.quoteId }).then(() => {
          this.$message.success('选标成功')
          this.loadDetail(this.dataForm.inquiryId)
        }).catch(() => {})
      }).catch(() => {})
    },
    convertPoFromView() {
      if (!this.dataForm.inquiryId) return
      this.$emit('convert-po', { inquiryId: this.dataForm.inquiryId, inquiryCode: this.dataForm.inquiryCode })
    },
    reload() { if (this.dataForm.inquiryId) this.init(this.dataForm.inquiryId, true) },
    submitWorkflow() {
      const ui = this.workflowUi
      if (ui && ui.workflowEnabled && !ui.definitionMatched) {
        this.$alert('尚未配置采购询价审批流程，请先在「审批流程定义」中新增并启用流程（至少一个审批步骤）后再提交。', '未配置审批流程', { type: 'warning', confirmButtonText: '我知道了' })
        return
      }
      this.$confirm('提交后将进入审批流程，期间不可修改，是否继续?', '提示', { type: 'warning' }).then(() => {
        this.approveDocActionLoading = true
        request.post('/workflow/submit', { bizType: 'purchaseInquiry', bizId: this.dataForm.inquiryId }).then(() => {
          this.$message.success('提交成功'); this.reload()
        }).catch(() => {}).finally(() => { this.approveDocActionLoading = false })
      }).catch(() => {})
    },
    wfApprove() {
      const task = this.dataForm.myPendingTask
      if (!task || !task.taskId) return
      this.$prompt('审批意见（可选）', '审批通过', { inputType: 'textarea', confirmButtonText: '通过' }).then(({ value }) => {
        this.approveDocActionLoading = true
        request.post('/workflow/task/approve', { taskId: task.taskId, comment: value || '' }).then(() => {
          this.$message.success('审批通过'); this.$emit('refreshDataList'); this.reload()
        }).catch(() => {}).finally(() => { this.approveDocActionLoading = false })
      }).catch(() => {})
    },
    wfReject() {
      const task = this.dataForm.myPendingTask
      if (!task || !task.taskId) return
      this.$prompt('请输入驳回原因', '审批驳回', {
        inputType: 'textarea', confirmButtonText: '驳回',
        inputValidator: v => !!(v && String(v).trim()) || '驳回原因不能为空'
      }).then(({ value }) => {
        this.approveDocActionLoading = true
        request.post('/workflow/task/reject', { taskId: task.taskId, comment: String(value).trim() }).then(() => {
          this.$message.success('已驳回'); this.$emit('refreshDataList'); this.reload()
        }).catch(() => {}).finally(() => { this.approveDocActionLoading = false })
      }).catch(() => {})
    },
    approveFromView() {
      this.$confirm('审核后可维护选标并转采购订单，是否继续?', '提示', { type: 'warning' }).then(() => {
        this.approveDocActionLoading = true
        request.post('/purchase/purchaseInquiry/approve', { inquiryId: this.dataForm.inquiryId }).then(() => {
          this.$message.success('审核成功'); this.$emit('refreshDataList'); this.reload()
        }).catch(() => {}).finally(() => { this.approveDocActionLoading = false })
      }).catch(() => {})
    },
    unapproveFromView() {
      this.$confirm('弃审后需确保无转采购记录，是否继续?', '提示', { type: 'warning' }).then(() => {
        this.approveDocActionLoading = true
        request.post('/purchase/purchaseInquiry/unapprove', { inquiryId: this.dataForm.inquiryId }).then(() => {
          this.$message.success('弃审成功'); this.$emit('refreshDataList'); this.reload()
        }).catch(() => {}).finally(() => { this.approveDocActionLoading = false })
      }).catch(() => {})
    },
    deleteFromView() {
      this.$confirm('确定删除该询价单?', '提示', { type: 'warning' }).then(() => {
        this.approveDocActionLoading = true
        request.post('/purchase/purchaseInquiry/delete', { inquiryId: this.dataForm.inquiryId }).then(() => {
          this.$message.success('删除成功'); this.visible = false; this.$emit('refreshDataList')
        }).catch(() => {}).finally(() => { this.approveDocActionLoading = false })
      }).catch(() => {})
    }
  }
}
</script>

<style scoped>
.doc-dialog-header { display: flex; align-items: flex-start; justify-content: space-between; gap: 12px; padding-right: 28px; }
.doc-dialog-title { font-size: 16px; font-weight: 600; line-height: 32px; }
.doc-dialog-actions { display: flex; flex-direction: column; align-items: flex-end; }
.doc-dialog-actions >>> .el-button-group { display: flex; flex-wrap: wrap; }
.wf-hint { margin-top: 6px; font-size: 12px; color: #e6a23c; max-width: 420px; text-align: right; }
</style>
